module.exports = __webpack_public_path__ + "static/media/my-friend-active-icon.5afde848.svg";